module.exports = __webpack_public_path__ + "static/media/combined_logos.d8abe798.svg";